<template>
  <div class="investigations">
    <h2>Investigations</h2>
    <loading :loading="isLoading">
      <div v-if="page">
        
        <!-- open investigations -->
        <b-card v-if="page.Investigations.length > 0" header="Open investigations (paged in 3s)">
          <search :showatonce="3" :items="page.Investigations">
            <template #results="data">
              <investigation-table :items="data.items"/>
            </template>
          </search>
        </b-card>
        <div v-if="page.Investigations.length === 0">
          You have no current investigations, why not start looking through your 
          <router-link :to="{name: 'alerts'}">notifications</router-link>
          and start one?
        </div>

        <b-card v-if="page.RecentlyClosed.length > 0" header="10 Most recently closed">
          <investigation-table :items="page.RecentlyClosed" :useclosedat="true"/>
        </b-card>

      </div>
    </loading>
  </div>
</template>

<script>
import Loading from '../components/Loading.vue'
import Search from '../components/Search.vue'
import InvestigationTable from '../components/InvestigationTable.vue'

export default {
  name: 'alerts',
  components: { Loading, Search, InvestigationTable },
  data() {
    return {
      isLoading: false,
      error: null,
      page: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch('getCache', { 
        name: 'investigations',
        fallback: () => {
          // fetch from reporting api
          this.isLoading = true;
          const { access_token } = this.$store.state.oidcStore;
          return this.$reportingApi.renderPage('panessex', access_token, {
            pageName: 'Investigations',
          })
          .then(page => {
            // add to cache
            this.$store.commit('cache', { name: 'investigations', item: page });
            return page;
          });
        }
      })
      .then(page => { this.page = page; this.isLoading = false })
      .catch(e => { this.error = e.message; this.isLoading = false })
    }
  }
}
</script>
